export function range(first: number, last: number) {
  return Array.from({ length: last - first + 1 }, (_, i) => first + i);
}
